import { render } from "./CreateProduct.vue?vue&type=template&id=9bbf12d6&scoped=true"
import script from "./CreateProduct.vue?vue&type=script&lang=js"
export * from "./CreateProduct.vue?vue&type=script&lang=js"

import "./CreateProduct.vue?vue&type=style&index=0&id=9bbf12d6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9bbf12d6"

export default script